export * from '@/common/style';
import { Box, styled } from '@mui/material';

export const OutletContainer = styled(Box)`
  margin-top: 64px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
